<template>
<!-- 获取验证码 -->
	<div class="phone-code">
    <a-row>
			<a-col class="col-from" :span="14">
				<a-input placeholder="请输入验证码" v-model="code" @blur="onBlur"></a-input>
			</a-col>
			<a-col class="col-from" :span="3"></a-col>
			<a-col class="col-from" :span="7">
				<a-button type="primary" @click="getPhoneVerify" :disabled="isCount" block>
					{{isCount ? count+' s' : '获取验证码'}}
				</a-button>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import md5 from 'js-md5'
import { sendSms } from '@/api/auth'

export default {
  props: {
    phone: String,
    phoneHint: String,
    code: String
  },
  data () {
    return {
      timer: null,
      count: '',
      isCount: false
    }
  },
  components: { },
  created () {
  },
  watch: {},
  methods: {
    // 获取验证码
    async getPhoneVerify () {
      const phone = this.phone
      const phoneHint = this.phoneHint
      if (!phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (phoneHint) {
        this.$message.error(phoneHint)
        return
      }
      const sig = md5(phone + 'yxczapp')
      const params = { phone, sig }
      const res = await sendSms(params)
      if (res.code === 0) {
        this.getCount()
      }
    },

    // 倒计时
    getCount () {
      if (!this.timer) {
        this.count = 60
        this.isCount = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--
          } else {
            this.isCount = false
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },

    // code
    onBlur () {
      this.$emit('getCode', 'bind', this.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-code {
	padding-top: 10px;
}
</style>
